import { render, staticRenderFns } from "./TabsController.vue?vue&type=template&id=bc0a9dc0&"
import script from "./TabsController.vue?vue&type=script&lang=ts&"
export * from "./TabsController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports